import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { MovingSpriteView } from '../../ui_canvas_engine/MovingSpriteView.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { Sprites } from '../UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { Point } from '@colonist/game-mechanic-validators';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIGameMapPirateController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.MapStateUpdated:
                this.updatePirate();
                break;
            default:
                break;
        }
    }
    updatePirate() {
        const pirateTile = this.uiGameManager.gameState.mapState.tileState.tiles[this.pirateState.locationTileIndex];
        if (pirateTile == undefined) return;
        if (this.lastPirateTile.sameTileHex(pirateTile)) return;
        this.movePirate(pirateTile);
    }
    movePirate(tile) {
        const pirateCoords = this.getPirateCoords(tile);
        this.pirateView.zIndex = this.uiGameManager.mapController.mapView.layers.pirate;
        this.uiGameManager.mapController.mapView.sortChildren();
        if (!this.uiGameManager.gameController.isReplay) this.pirateView.animationController.animationCompleteCallBack = ()=>AudioManager.play(AudioType.PiratePlace);
        this.pirateView.animationController.animateTo(pirateCoords);
        this.lastPirateTile = tile;
    }
    getPirateCoords(tile) {
        const tileCenter = tile.hexFace.toPixel(this.uiGameManager.mapController.mapView.mapCenter, this.uiGameManager.mapController.mapView.hexagonHeight / 2);
        const leftXPosition = tileCenter.x - this.uiGameManager.mapController.mapView.pirateRadius * 1.2;
        const leftYPosition = tileCenter.y - this.uiGameManager.mapController.mapView.pirateRadius * 0.25;
        const rightXPosition = tileCenter.x + this.uiGameManager.mapController.mapView.pirateRadius * 0.1;
        const rightYPosition = tileCenter.y - this.uiGameManager.mapController.mapView.pirateRadius * 0.3;
        const isPortOnBottomEastSideOfTile = this.uiGameManager.gameState.mapState.isPortOnEastSideOfTile(tile);
        const x = isPortOnBottomEastSideOfTile ? leftXPosition : rightXPosition;
        const y = isPortOnBottomEastSideOfTile ? leftYPosition : rightYPosition;
        return new Point(x, y);
    }
    constructor(uiGameManager, pirateState){
        this.uiGameManager = uiGameManager;
        this.pirateState = pirateState;
        const tileWithPirate = this.uiGameManager.gameState.mapState.tileState.tiles[this.pirateState.locationTileIndex];
        if (tileWithPirate == undefined) return;
        this.lastPirateTile = tileWithPirate;
        const pirateCoords = this.getPirateCoords(this.lastPirateTile);
        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_pirate_ship);
        this.pirateView = new MovingSpriteView(pirateCoords.x, pirateCoords.y, this.uiGameManager.mapController.mapView.pirateRadius, this.uiGameManager.mapController.mapView.pirateRadius, this.uiGameManager.mapController.mapView, texture);
        this.pirateView.zIndex = this.uiGameManager.mapController.mapView.layers.pirate;
        this.pirateView.animationController.animationCompleteCallBack = ()=>{
            this.pirateView.zIndex = this.uiGameManager.mapController.mapView.layers.pirate;
            this.uiGameManager.mapController.mapView.sortChildren();
        };
        const pirateTipTitle = {
            key: 'strings:game.tips.pirate.title'
        };
        const pirateTipBody = [
            {
                key: 'strings:game.tips.pirate.body.0'
            },
            {
                key: 'strings:game.tips.pirate.body.1'
            }
        ];
        this.pirateView.setTip(pirateTipTitle, pirateTipBody);
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
